import PropTypes from "prop-types"
import React, { useState } from "react"
import { useQuery } from "react-query"

import ChatThreadList from "src/components/ChatThreadList"

import { queryContactMessages } from "src/api/Contacts"

import { updateUrlQueryParams } from "src/utils/url/parsing/marina"

const getInitialStateFromUrl = () => {
  const params = new URLSearchParams(window.location.search)
  return {
    readStatus: params.get("read_status") || "all",
    types: params.getAll("types"),
    page: parseInt(params.get("page"), 10) || 1,
  }
}

const ContactMessagesTab = ({ contactId, marinaId, initialData }) => {
  const [initialState] = useState(getInitialStateFromUrl)
  const [filters, setFilters] = useState({
    readStatus: initialState.readStatus,
    types: initialState.types,
  })
  const [page, setPage] = useState(initialState.page)

  const { data, isFetching } = useQuery(
    ["contactMessages", contactId, filters, page],
    () => queryContactMessages(marinaId, contactId, { ...filters, page }),
    {
      initialData,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  )

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters)
    setPage(1)
    updateUrlQueryParams({
      read_status:
        newFilters.readStatus !== "all" ? newFilters.readStatus : null,
      types: newFilters.types.length > 0 ? newFilters.types : null,
      page: null,
    })
  }

  const handlePageChange = ({ selected }) => {
    setPage(selected)
    updateUrlQueryParams({
      read_status: filters.readStatus !== "all" ? filters.readStatus : null,
      types: filters.types.length > 0 ? filters.types : null,
      page: selected > 1 ? selected : null,
    })
  }

  return (
    <div className={"p-4"}>
      <ChatThreadList
        items={data?.data || []}
        isLoading={isFetching && !data}
        showFilters
        filters={filters}
        onFilterChange={handleFilterChange}
        pagination={{
          page: data?.pagination?.currentPage || 1,
          pageCount: data?.pagination?.totalPages || 1,
          totalCount: data?.pagination?.totalCount || 0,
        }}
        onPageChange={handlePageChange}
        emptyState={{
          title: "No messages yet",
          description: "Message threads with this customer will appear here.",
          icon: "fa-envelope",
        }}
      />
    </div>
  )
}

ContactMessagesTab.propTypes = {
  contactId: PropTypes.string.isRequired,
  marinaId: PropTypes.string.isRequired,
  initialData: PropTypes.shape({
    items: PropTypes.array,
    pagination: PropTypes.object,
  }),
}

export default ContactMessagesTab
